/**
 * @typedef {Object} NotificationDto
 * @property {number} notificationId
 * @property {string} notificationType
 * @property {string} entityType
 * @property {number} entityId
 * @property {string} [orderNumber]
 * @property {string} [itemNumber]
 * @property {string} [stepName]
 * @property {string} [stationName]
 * @property {boolean} isRead
 * @property {string} createdDate
 */

const BASE_PATH = 'v1/Notifications';

export default function (instance) {
  return {
    getRecent(take = 50) {
      return instance.get(BASE_PATH, { params: { take } });
    },
    markRead(id) {
      return instance.patch(`${BASE_PATH}/${id}/read`);
    },
    markAllRead() {
      return instance.patch(`${BASE_PATH}/read-all`);
    }
  };
}
